import { Box, Button, TextField, FormGroup, FormControlLabel, Checkbox, IconButton } from '@mui/material'
import React from 'react';
// import MUIRichTextEditor from "mui-rte";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import CKEditorInspector from '@ckeditor/ckeditor5-inspector';
// import "../../../pages/Login/login.css"
import useFetch from "../../../../utils/useFetch";
import axios from "../../../../utils/fvAxios";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import CancelIcon from "@mui/icons-material/Cancel"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Stack from '@mui/material/Stack';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Picker } from 'emoji-mart';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";




export default function EmailTemplate({ remote, ClientId, TEMPID, PQID, handleClose1 }) {

    const [Emailtemplate, setEmailtemplate] = useState({});
    const [to, setTo] = useState("");
    const [ccAddress, setCcAddress] = useState("");
    const [bccAddress, setBccAddress] = useState("");
    const [subject, setSubject] = useState("");
    const [body1, setBody1] = useState("");
    const [body, setBody] = useState(body1);
    const [emailComment, setEmailComment] = useState("");
    const [checked, setChecked] = useState(false);

    const [Toerror, setToError] = useState("");
    const [Ccerror, setCcError] = useState("");
    const [Subjecterror, setSubjectError] = useState("");
    const [Bodyerror, setBodyError] = useState("");
    const [attachments, setAttachments] = useState(Emailtemplate?.defaultAttachmentsList || []);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoader, setIsLoader] = useState(true);

    const { data: res } = useFetch(
        "Prequalification/GetEmailTemplateInfoForCompose?templateId=" +
        TEMPID +
        "&prequalificationId=" +
        PQID +
        "&selectedSubClientId=" +
        ClientId
    );
    useEffect(() => {

        if (res?.data) {
            setEmailtemplate(res?.data);
            setIsLoader(false);
        }
        setTo(res?.data?.toAddress);
        setCcAddress(res?.data?.ccAddress);
        setBccAddress(res?.data?.sendCopyToMySelf == true ? res?.data?.bccAddress : "");
        setSubject(res?.data?.subject);
        setBody(res?.data?.body);
        setBody1(res?.data?.body)
        setEmailComment(res?.data?.emailComment);
        setChecked(res?.data?.sendCopyToMySelf);
        setAttachments(res?.data?.defaultAttachmentsList)

    }, [res]);

    const ChangeTo = (e) => {
        let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        let result = e?.target?.value?.split(",");
        result.forEach((address) => {
            if (regex?.test(address) == true) {
                setToError("");
                setTo(e?.target?.value);
            } else {
                setToError("Please check email");
                setTo(e?.target?.value);
            }

        });

    }

    const ChangeCc = (e) => {
        let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
        let result = e?.target?.value?.split(",");
        result?.forEach((address) => {
            if (regex?.test(address) == true && e?.target?.value != "") {
                setCcError("");
                setCcAddress(e?.target?.value);
            } else if (e?.target?.value == "") {
                setCcError("");
                setCcAddress(e?.target?.value);
            } else {
                setCcError("Please check Cc email");
                setCcAddress(e?.target?.value);
            }

        });

    }

    const ChangeSubject = (e) => {
        if (e?.target?.value == "") {
            setSubjectError("Please enter subject field");
            setSubject(e?.target?.value);
        } else {
            setSubjectError("");
            setSubject(e?.target?.value);
        }

    }
    const ChangeBody = (data) => {
        if (data == "") {
            setBodyError("Please enter contact field");
            setBody(data);
        } else {
            setBodyError("");
            setBody(data);
        }
    }

    const HandleCheck = (check) => {
        if (check == false) {
            setChecked(check);
            setBccAddress("");
        } else {
            setChecked(check);
            setBccAddress(Emailtemplate?.bccAddress);
        }

    }



    const getValue = (e) => {
        const defaultAttactment = Emailtemplate?.defaultAttachmentsList?.filter((r) => (r.attachmentId !== e))
    };



    const [file, setFile] = useState();
    const [file1, setFile1] = useState();
    const [file2, setFile2] = useState();
    const [file3, setFile3] = useState();
    const [file4, setFile4] = useState();
    const [fileName, setFileName] = useState();
    const saveFile = (e) => {
        setFile(e?.target?.files[0]);

        setFileName(e?.target?.files[0]?.name);
    };
    const saveFile1 = (e) => {
        setFile1(e?.target?.files[0]);
    };
    const saveFile2 = (e) => {
        setFile2(e?.target?.files[0]);
    };
    const saveFile3 = (e) => {
        setFile3(e?.target?.files[0]);
    };
    const saveFile4 = (e) => {
        setFile4(e?.target?.files[0]);
    };
  

    const removeAttachment = (attachmentId) => {
        setAttachments(prev => prev?.filter(attachment => attachment.attachmentId !== attachmentId));
    };

    const SandEmail = async () => {
        // const Upload = [file, file1, file2, file3, file4]  && Bodyerror == ""
        setIsLoading(true);
        if (to != "" && subject != "" && Toerror == "" && Subjecterror == "" && Ccerror == "" && body != "") {
            const defaultAttachmentsLists = attachments?.map((r) => {
                return {
                    AttachmentName: r?.attachmentName,
                    AttachmentId: r?.attachmentId,
                    isActive: r?.isActive,
                };
            });

            // const myJSON = JSON.stringify(defaultAttachmentsLists);

            const formData = new FormData();

            formData.append("templateId", TEMPID);
            formData.append("prequalificationId", PQID);

            formData.append("toAddress", to);
            formData.append("ccAddress", ccAddress);

            formData.append("subject", subject);
            formData.append("body", body);

            formData.append("sendCopyToMySelf", checked);
            formData.append("attachments", Emailtemplate?.attachments);
            formData.append("emailComment", emailComment);
            formData.append("bccAddress", bccAddress);
            formData.append("DefaultAttachmentsListJson", JSON.stringify(defaultAttachmentsLists));
            formData.append("subSectionId", Emailtemplate?.subSectionId,);
            formData.append("loginUser", Emailtemplate?.loginUser);
            formData.append("formAttachments", file);
            formData.append("formAttachments", file1);
            formData.append("formAttachments", file2);
            formData.append("formAttachments", file3);
            formData.append("formAttachments", file4);
            formData.append("testFile", file);


            axios.post("Prequalification/SaveAndSendComposedEmailForPQ", formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            ).then(res => {
                if (res?.data?.responseMessage == "Success") {
                    toast.success(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setIsLoading(false);
                    handleClose1();
                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setIsLoading(false);
                }
            }).catch(err => {
                console.log(err)
            })
        } else {
            if (Ccerror != "") {
                toast.error("Please check Cc  email", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                toast.error("Please enter mandatory fields", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            setIsLoading(false);
        }

    };
    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'background',
        'list',
        'align',
        // 'link',
        'image',
        'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // ['link'],
            ['clean'],

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };



    const handleUndo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.undo();
    };

    const handleRedo = () => {
        const quill = quillRef.current.getEditor();
        quill.history.redo();
    };
    const quillRef = React.createRef();
  
    return (
        <Box sx={{ padding: '20px', backgroundColor: "" }}>
            <ToastContainer />
            <b style={{ fontSize: "25px" }}>Send Email</b>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading ||isLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec" sx={{ padding: "13px", backgroundColor: "#fff", marginTop: "5px" }}>
                <span style={{ fontSize: "14px" }}>To <span style={{ color: "red" }}>*</span></span>
                <br />
                <Stack direction="row" spacing={2}>
                    <TextField placeholder="Email" sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={to || ""} variant="outlined" size="small" onChange={(e) => ChangeTo(e)} />
                    <p style={{ color: "red" }}>{Toerror}</p>
                </Stack>
                <br />
                <span style={{ fontSize: "14px" }}>CC</span>
                <br />
                <Stack direction="row" spacing={2}>
                    <TextField placeholder="CC" sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={ccAddress || ""} variant="outlined" size="small" onChange={(e) => ChangeCc(e)} />
                    <p style={{ color: "red" }}>{Ccerror}</p>
                </Stack>
                <br />
                <span style={{ fontSize: "14px" }}>BCC</span>
                <br />
                <TextField placeholder="BCC" disabled={true} sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={bccAddress || ""} variant="outlined" size="small" />
                <br />

                <div style={{ marginLeft: "5px" }} >
                    <FormControlLabel
                        control={<Checkbox checked={checked == true ? true : false} onChange={(e) => HandleCheck(e?.target?.checked)} size="small" sx={{ marginLeft: "5px" }} />}
                        label="Uncheck, if you do not wish to have a copy via BCC."
                    />
                </div>

                <br />
                <span className='abc' style={{ fontSize: "14px" }}>Subject <span style={{ color: "red" }}>*</span></span>
                <br />
                <Stack direction="row" spacing={2}>
                    <TextField placeholder="Subject" sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={subject || ""} variant="outlined" size="small" onChange={(e) => ChangeSubject(e)} />
                    <p style={{ color: "red" }}>{Subjecterror}</p>
                </Stack>
                <br />
                <span style={{ fontSize: "14px" }}>Content<span style={{ color: "red" }}>*</span></span>
                <div>
                    <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                        <UndoIcon />
                    </IconButton>
                    <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                        <RedoIcon />
                    </IconButton>

                    <ReactQuill
                        ref={quillRef}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={body}
                        onChange={setBody}
                    />
                </div>
                <p style={{ color: "red" }}>{Bodyerror}</p>

                <br />
                <div>
                    {attachments?.map((r, index) => (
                        <div key={r?.attachmentId}>
                            <Stack direction={'row'} sx={{ alignItems: "center" }}>
                                <p style={{ width: "350px" }}>{r?.attachmentName}</p>
                                <CancelIcon
                                    className='mx-3'
                                    onClick={() => removeAttachment(r?.attachmentId)}
                                    style={{ color: "red" }}
                                />
                            </Stack>
                        </div>
                    ))}
                    <span className="abc" style={{ fontSize: "17px" }}>
                        Attachments
                    </span>
                    <br />

                    <br />
                    <span
                        style={{
                            display:
                            attachments?.[0] ? "none" : "",
                        }}
                    >
                        <input className="mt-2" type="file" onChange={saveFile} />{" "}
                        <CancelIcon style={{
                            color: "red", display:
                                !attachments?.[0] ? "none" : "",
                        }} />
                    </span>
                    <br />
                    <span
                        style={{
                            display:
                            attachments?.[1] ? "none" : "",
                        }}
                    >
                        <input className="mt-2" type="file" onChange={saveFile1} />{" "}
                        <CancelIcon style={{
                            color: "red", display:
                                !attachments?.[1] ? "none" : "",
                        }} />
                    </span>
                    <br />
                    <span
                        style={{
                            display:
                            attachments?.[2] ? "none" : "",
                        }}
                    >
                        <input className="mt-2" type="file" onChange={saveFile2} />{" "}
                        <CancelIcon style={{
                            color: "red", display:
                                !attachments?.[2] ? "none" : "",
                        }} />
                    </span>
                    <br />
                    <span
                        style={{
                            display:
                            attachments?.[3] ? "none" : "",
                        }}
                    >
                        <input className="mt-2" type="file" onChange={saveFile3} />{" "}
                        <CancelIcon style={{
                            color: "red", display:
                                !attachments?.[3] ? "none" : "",
                        }} />
                    </span>
                    <br />
                    <span
                        style={{
                            display:
                            attachments?.[4] ? "none" : "",
                        }}
                    >
                        <input className="mt-2" type="file" onChange={saveFile4} />{" "}
                        <CancelIcon style={{
                            color: "red", display:
                                !attachments?.[4] ? "none" : "",
                        }} />
                    </span>
                    <br />
                    <div></div>
                    {/* <span className="mt-2" style={{ fontSize: "14px" }}>
                        Add Comment
                    </span> */}
                    <br />
                </div>
                <span style={{ fontSize: "14px" }}>Add Comment</span>
                <br />
                <TextareaAutosize
                    aria-label="minimum height"
                    minRows={3}
                    value={emailComment || ""}
                    placeholder="Add Comment..."
                    style={{ width: 250 }}
                    onChange={(e) => setEmailComment(e?.target?.value)}
                />
                <br />

                <Button variant="contained" sx={{ padding: "10px", marginRight: "10px" }} onClick={SandEmail}>Send Email</Button>
                <Button variant="outlined" sx={{ padding: "10px" }} onClick={remote}>Cancel</Button>
            </Box>

        </Box>
    )
}